import { useEffect, useState } from "react";
import { Menu, MenuItem, Sidebar } from "react-pro-sidebar";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { handleSidebar } from "../store/reducer";
import useWindowSize from "../../hooks/useWindowSize";

import {
  IoIosArrowDroprightCircle,
  IoIosArrowDropleftCircle,
} from "react-icons/io";

import { BiMenuAltLeft } from "react-icons/bi";
import {
  BiographiesIcon,
  DashboardIcon,
  HelpCenterIcon,
  Logout,
  LogoutSidebarIcon,
  MemoirsIcon,
  SidebarLogo,
  SubscriptionIcon,
  UserIcon,
} from "../../constants/images";
import DeleteModal from "@/components/common/DeleteModal";
import { RouteConstants } from "@/routes/routesConstants";
import { logoutUser } from "@/modules/authentication/store/actions";
import { logOut } from "@/modules/authentication/store/reducer";

const menuItems = [
  {
    name: "Dashboard",
    icon: <img src={DashboardIcon} className="sidebarIcon" />,
    path: "/dashboard",
    header: "Dashboard",
  },
  {
    name: "Users",
    icon: <img src={UserIcon} />,
    path: "/users",
    header: "Users",
  },
  {
    name: "Memoirs",
    icon: <img src={MemoirsIcon} className="sidebarIcon" />,
    path: "/memoirs",
    header: "Memoirs",
  },
  {
    name: "Biographies",
    icon: <img src={BiographiesIcon} className="sidebarIcon" />,
    path: "/biographies",
    header: "Biographies",
  },
  {
    name: "Premium",
    icon: <img src={SubscriptionIcon} className="sidebarIcon" />,
    path: "/subscription",
    header: "Premium Users",
  },
];

const Header = () => {
  const pathname = window.location.pathname;
  const dispatch = useDispatch();
  const { id } = useParams();
  const [menuCollapse, setMenuCollapse] = useState(false);
  const [active, setActive] = useState({ tab: "Users", header: "Users" });
  const [isOpenMenu, setIsMenuOpen] = useState(false);
  const { isMobile } = useSelector((state) => state.layout);
  const { width } = useWindowSize();
  const [isOpen, setIsOpen] = useState({ show: false, data: null });
  const navigate = useNavigate();
  const isMobileView = width <= 885;
  const menuIconClick = () => {
    if (isMobileView) {
      setIsMenuOpen(!isOpenMenu);
      dispatch(handleSidebar(false));
    } else {
      menuCollapse ? setMenuCollapse(false) : setMenuCollapse(true);
      dispatch(handleSidebar(menuCollapse ? false : true));
    }
  };

  useEffect(() => {
    if (window.location.pathname === "/add-plans") {
      setActive({ ...active, tab: "Add Plans", header: "Add Plans" });
    } else if (id) {
      setActive({ ...active, tab: "Edit Plans", header: "Edit Plans" });
    } else {
      let tab = menuItems.find((ele) => ele?.path === pathname);
      setActive({ ...active, tab: tab?.tab, header: tab?.header });
    }
  }, [pathname]);

  useEffect(() => {
    dispatch(handleSidebar(false));
  }, []);
  const handleClose = () => {
    setIsOpen({ show: false });
  };

  const handleOnDelete = () => {
    dispatch(logOut());
    navigate(RouteConstants.login);
    handleClose();
  };
  return (
    <>
      <div className="header-container d-flex align-items-center ">
        <span
          className={`header-text d-flex align-items-center gap-2 justify-content-between ${isMobileView
            ? "small-screen"
            : !isMobileView && isMobile
              ? "mobile-screen"
              : width > 885 && !isMobile && "desktop-screen"
            }`}
        >
          <div
            onClick={menuIconClick}
            className="d-flex gap-2 align-items-center justify-content-between"
          >
            {!isMobileView ? (
              menuCollapse ? (
                <IoIosArrowDroprightCircle
                  size={40}
                  color="#C7D0F880"
                  className="header-menu-collapse"
                />
              ) : (
                <IoIosArrowDropleftCircle
                  size={40}
                  color="#C7D0F880"
                  className="header-menu-collapse"
                />
              )
            ) : (
              <BiMenuAltLeft />
            )}
            {active?.header}
          </div>
          <div className="d-flex gap-2 align-items-center">
            <div
              className="open-web-mail"
              onClick={() =>
                window.open("https://webmail.memorem.co.uk", "_blank")
              }
            >
              Open Webmail
            </div>
          </div>
        </span>
      </div>
      {((!isMobileView && !isOpenMenu) || (isMobileView && isOpenMenu)) && (
        <div
          id="header"
          className={isOpenMenu && isMobileView ? "header-top-size" : ""}
        >
          <Sidebar collapsed={menuCollapse} className="sidebar-container">
            <div className="pro-sidebar-layout">
              <div
                className="pro-sidebar-header "
                onClick={() => navigate(RouteConstants.dashboard)}
              >
                <img src={SidebarLogo} className="sidebar-logo mb-lg-3 " />
              </div>

              <div className="pro-sidebar-content">
                <Menu iconShape="square  ">
                  <span className="text-muted ms-4 mt-4 sidebarMenuLabelText">
                    Menu
                  </span>
                  {menuItems?.map((ele, index) => {
                    return (
                      <MenuItem
                        key={index}
                        active={ele?.path == pathname}
                        icon={ele?.icon}
                        onClick={() => {
                          navigate(ele?.path);
                          setActive({
                            ...active,
                            tab: ele?.name,
                            header: ele?.header,
                          });
                          if (isMobileView) {
                            setIsMenuOpen(false);
                          }
                        }}
                        title={menuCollapse ? ele?.name : ""}
                        className={`${ele?.path == pathname ? "active-tab" : ""
                          }`}
                      >
                        {ele?.name}
                      </MenuItem>
                    );
                  })}
                </Menu>
                <div className="">
                  <Menu iconShape="square">
                    {/* <span className="text-muted ms-4 sidebarMenuLabelText">
                      Support
                    </span> */}
                    {/* <MenuItem
                      title={menuCollapse ? "Help Center" : ""}
                      icon={<img src={HelpCenterIcon} />}
                    >
                      Help Center
                    </MenuItem> */}
                    <MenuItem
                      onClick={() => setIsOpen({ show: true })}
                      className="logoutBtn"
                      title={menuCollapse ? "Logout" : ""}
                      icon={<img src={LogoutSidebarIcon} />}
                    >
                      Logout
                    </MenuItem>
                  </Menu>
                </div>
              </div>
            </div>
          </Sidebar>
        </div>
      )}
      <DeleteModal
        isOpen={isOpen?.show}
        handleClose={handleClose}
        handleOnDelete={handleOnDelete}
        data={`Are you sure you want to logout?`}
        buttonContent={`Yes, Logout`}
        IsIcon={true}
        icon={Logout}
      />
    </>
  );
};

export default Header;
